import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { CSVLink } from "react-csv";

const CSVButton = (props) =>{
    const [downloadData, setDownloadData] = useState([]);
    const fileName = props.fileName;

    //Internal ID for secure multiple CSV Buttons
    const [internalID] = useState(Math.floor(Math.random() * 100000))


    const getCurrentDate = (separator=' ') => {
        let newDate = (new Date()).toISOString().split('T')[0]; //Format YYYY-MM-DD
        let newTime = new Date().toLocaleTimeString({hour: "2-digit", minute: "2-digit", second: "2-digit"})
        return `${newDate}${separator}${newTime}`
    }
    const downloadCSV = (data)=> {
        setDownloadData(data)
        let idTag = "csvLinkAccounts_"+fileName+"_"+internalID;
        let csvLink = document.querySelector('a[id="'+idTag+'"]');
        ['mousedown', 'click', 'mouseup'].forEach(mouseEventType =>
            csvLink.dispatchEvent(
              new MouseEvent(mouseEventType, {
                  view: window,
                  bubbles: true,
                  cancelable: true,
                  buttons: 1
              })
            )
        );
    }
    const _onClick = () => {
        if (props.onClick){
          props.onClick(downloadCSV)
        }
      };
    return (
      <div>
        <Button {...props} onClick={_onClick}>
          {props.label}
        </Button>
        <CSVLink
            hidden id={"csvLinkAccounts_"+fileName+"_"+internalID}
            data={downloadData}
            filename={`${getCurrentDate()}-`+fileName+ '.csv'}
            >
        </CSVLink>
      </div>
    );
  }


export default CSVButton;